import React from 'react';
import { Flame, Swords, Sparkles, Map } from 'lucide-react';
import { gameFeatures } from '../mockData';

const iconMap = {
  Flame: Flame,
  Swords: Swords,
  Sparkles: Sparkles,
  Map: Map
};

const FeaturesSection = () => {
  return (
    <section id="features" className="section-padding bg-page-bg">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="heading-2 mb-6">Epic Combat Awaits</h2>
          <p className="body-medium text-text-secondary max-w-2xl mx-auto">
            Experience intense battles with cutting-edge gameplay mechanics
          </p>
        </div>

        <div className="pixel-pushers-grid">
          {gameFeatures.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div key={feature.id} className="feature-card">
                <div className="feature-icon">
                  <IconComponent size={40} strokeWidth={1.5} />
                </div>
                <h3 className="heading-4 mb-4">{feature.title}</h3>
                <p className="body-small">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
